import { Minus, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

const rounded = (value) => Math.round(value * 10) / 10;

export const QuantityStepper = ({
  id,
  label,
  value,
  min,
  max,
  step = 1,
  unit = "",
  disabled = false,
  onChange,
}) => {
  const amount = Number(value);
  const ready = Number.isFinite(amount);
  const decreaseDisabled = disabled || !ready || amount <= min;
  const increaseDisabled = disabled || !ready || amount >= max;

  return (
    <div className="supplement-quantity-stepper" aria-label={label} data-testid={`${id}-stepper`}>
      <Button type="button" variant="outline" size="icon" disabled={decreaseDisabled} onClick={() => onChange(rounded(Math.max(min, amount - step)))} aria-label={`Decrease ${label}`} data-testid={`${id}-decrease-button`}>
        <Minus aria-hidden="true" />
      </Button>
      <output aria-live="polite" data-testid={`${id}-value`}>
        <strong>{ready ? amount : "—"}</strong>
        {unit && <span>{unit}</span>}
      </output>
      <Button type="button" variant="outline" size="icon" disabled={increaseDisabled} onClick={() => onChange(rounded(Math.min(max, amount + step)))} aria-label={`Increase ${label}`} data-testid={`${id}-increase-button`}>
        <Plus aria-hidden="true" />
      </Button>
    </div>
  );
};